import * as React from "react";

export default React.createContext<{
    dispatch: (action: string, params?: any) => void;
    translate: (key: string, params?: { [key: string]: string }) => string;
    locale: string;
    fullwidth: boolean;
}>(undefined);